import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import dayjs from 'dayjs';

import { SettlementsNode } from '../graphQL/types';
import SettlementBadge from './SettlementBadge';
import { ICON_ARROW_BLACK } from 'assets/icons';
import Text from 'components/common/Text';
import { SETTLEMENT_DETAIL_PATH_DEFAULT } from 'constants/path';
import Row from 'components/common/Row';
import Column from 'components/common/Column';
import BasicButton from 'components/Button/BasicButton';
import CommonImage from 'components/common/CommonImage';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 14px;
  border-radius: 9999px;
  background: #f4f4f5;

  color: #1b1c1e;

  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.6px;
`;

interface SettlementItemIProps {
  settlementItem: SettlementsNode;
}

const SettlementItem: React.FC<SettlementItemIProps> = props => {
  const { settlementItem } = props;

  const isMinusSettlement =
    Number(settlementItem.totalPayment.value) +
      Number(settlementItem.totalFee.value) <
    0;

  return (
    <Container>
      <Column gap="4px" align="flex-start">
        <Row gap="8px">
          <SettlementBadge
            status={
              settlementItem.invoice !== null
                ? settlementItem.invoice.status
                : null
            }
          />
          <Text color="#1b1c1e" size="24px" style={{ lineHeight: '36px' }}>
            {/* <span
              style={{
                textDecorationLine: handleIsOpenAllSettlementItemModal
                  ? "underline"
                  : "none",
              }}
              onClick={() => {
                handleIsOpenAllSettlementItemModal &&
                  handleIsOpenAllSettlementItemModal();
              }}
            >
              {settlementItem.title.slice(6, 15)}
            </span>{" "} */}
            {settlementItem.title.slice(6, 15)} 정산
          </Text>
        </Row>
        <Text color="#989ba2" weight={400}>
          {dayjs(settlementItem.startedDate).format('M월 D일(dd)')}부터{' '}
          {dayjs(settlementItem.endedDate).format('M월 D일(dd)')}까지
        </Text>
      </Column>
      <Column gap="32px" align="flex-start">
        <Row>
          <Text
            color={isMinusSettlement ? '#FF4242' : '#1b1c1e'}
            size="32px"
            weight={600}
            style={{ lineHeight: '48px' }}
          >
            {(
              Number(settlementItem.totalPayment.value) +
              Number(settlementItem.totalFee.value)
            ).toLocaleString()}
            원
          </Text>
        </Row>
        {/* <Row justifyContent="flex-end" gap="8px">
          <BasicButton content="정산 미리보기" onClick={() => {}} />
          <BasicButton
            content={
              <Row>
                <span>정산 내역</span>
                <CommonImage src={ICON_ARROW_BLACK} onClick={() => {}} />
              </Row>
            }
            onClick={() => {}}
          />
          <Button onClick={handleOpenSettlementInformationModal}>
            정산 정보
          </Button>
          {type === undefined && (
            <Button
              onClick={() => {
                navigate(
                  `${SETTLEMENT_DETAIL_PATH_DEFAULT}/${settlementItem.id}`,
                );
              }}
              style={{ padding: '6px 8px 6px 14px' }}
            >
              판매 내역
              <img src={ICON_ARROW_BLACK} alt="icon arrow black" />
            </Button>
          )}
        </Row> */}
      </Column>
    </Container>
  );
};

export default SettlementItem;
